module.exports = require('./helpers/bundle-url').getBundleURL('isz6D') + "logo.c51670a8.svg";